import tr from "./tr";
import en from "./en";

import enValid from "vee-validate/dist/locale/en.json";
import trValid from "vee-validate/dist/locale/tr.json";

const trExtended = Object.assign(tr, {validation: Object.assign(tr.validation || {}, trValid.messages)});
const enExtended = Object.assign(en, {validation: Object.assign(en.validation || {}, enValid.messages)}); 
 
export default {
  tr: trExtended,
  en: enExtended
};
